// js/unsaved-changes-warning.js
// Warns the user before they navigate away from a long form (page refresh,
// tab close, back/forward) with unsaved changes. Scoped to forms that opt in
// via data-warn-on-leave="true" — not applied site-wide.

/**
 * Wire up a page-level beforeunload warning for any opted-in forms present
 * on the page. Bails silently if none are found.
 */
export function initUnsavedChangesWarning() {
    const forms = Array.from(document.querySelectorAll('form[data-warn-on-leave="true"]'));
    if (!forms.length) return;

    const dirtyForms = new Set();

    forms.forEach(form => {
        form.addEventListener('input', () => dirtyForms.add(form));
        form.addEventListener('change', () => dirtyForms.add(form));
        form.addEventListener('submit', () => dirtyForms.delete(form));
    });

    window.addEventListener('beforeunload', event => {
        if (!dirtyForms.size) return;

        event.preventDefault();
        event.returnValue = '';
    });
}
